import { render, staticRenderFns } from "./DictCascader.vue?vue&type=template&id=ff5776a8&scoped=true&"
import script from "./DictCascader.vue?vue&type=script&lang=js&"
export * from "./DictCascader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff5776a8",
  null
  
)

export default component.exports